import { useBoundaryTerritoryGroupsSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { useMapSettingsGroupingActiveGroupColumnsSelector } from '~/store/mapSettings/grouping/mapSettingsGrouping.selectors';
import { useMapSettingsExportImageSettingsModeSelector } from '~/store/mapSettings/toolsState/exportImageSettings/exportImageSettings.selectors';
import { MasterKeyComponent } from './masterKey.component';

export const MasterKeyContainer = ({
  allowScrollbar = true,
  allowShowTabs = true,
  onClose,
}: {
  allowScrollbar?: boolean;
  allowShowTabs?: boolean;
  onClose?: () => void;
}) => {
  const isGroupingActive = useMapSettingsGroupingActiveGroupColumnsSelector().length > 0;
  const hasBoundaryGroups = useBoundaryTerritoryGroupsSelector().length > 0;
  const isExportImageMode = !!useMapSettingsExportImageSettingsModeSelector();

  return (
    <MasterKeyComponent
      isGroupingActive={isGroupingActive}
      hasBoundaryGroups={hasBoundaryGroups}
      allowShowTabs={!isExportImageMode && allowShowTabs}
      allowScrollbar={allowScrollbar}
      onClose={onClose}
    />
  );
};
